import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ModalService {
  /**
   *
   */
  private currentComponent: any = {};

  /**
   *
   */
  private loadedComponents: Array<any> = [];

  /**
   *
   */
  public componentChangeEvent: Subject<any> = new Subject<any>();

  /**
   *
   */
  private closeEvent: Subject<boolean> = new Subject<boolean>();

  load(
    componentData: { name: string; close?: boolean; data?: any } = {
      name: null,
      close: true,
      data: null,
    },
  ): void {
    this.componentChangeEvent.next(componentData);
  }

  onCloseEvent() {
    return this.closeEvent.asObservable();
  }

  closePopup() {
    this.closeEvent.next(true);
  }
}
